import React, { MouseEvent, useState } from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'

import OptionsMenu, { OptionProps } from 'components_new/molecules/OptionsMenu'
import Tooltip from 'components_new/atoms/Tooltip'

interface GenericWidgetMenuProps {
  disableFullsize?: boolean
  editMode: boolean
  fullSize: boolean
  onFullSize: () => void
  onSettings?: () => void
  options?: OptionProps[]
  scaleFactor: number
}

const GenericWidgetMenu = (props: GenericWidgetMenuProps) => {
  const {
    disableFullsize,
    editMode,
    fullSize,
    onFullSize,
    onSettings,
    options,
    scaleFactor
  } = props

  const { t } = useTranslation()

  const ICON_BUTTON_SIZE = fullSize ? 32 : 26
  const ICON_SIZE = fullSize ? 24 : 20

  const [optionsMenuAnchorEl, setOptionsMenuAnchorEl] =
    useState<HTMLElement | null>(null)

  return (
    <>
      <Box
        className="widget-menu"
        sx={{
          height: 'auto',
          pb: 0.75 * scaleFactor,
          pt: 0.75 * scaleFactor,
          pl: 1 * scaleFactor,
          position: 'absolute',
          right: 0,
          top: 0,
          transition: 'all 0.5s ease',
          width: 'auto',
          zIndex: 3
        }}
      >
        {/*-- buttons --*/}
        {[
          ...(disableFullsize
            ? []
            : [
                {
                  icon: {
                    name: !fullSize
                      ? ('ZoomInOutlined' as const)
                      : ('ZoomOutOutlined' as const)
                  },
                  id: 'full-size',
                  onClick: onFullSize,
                  tooltip: t('global', 'open')
                }
              ]),
          ...(editMode && onSettings
            ? [
                {
                  icon: { name: 'Edit' as const },
                  id: 'edit',
                  onClick: onSettings,
                  tooltip: t('global', 'edit')
                }
              ]
            : []),
          ...(options && options.length > 0
            ? [
                {
                  icon: { name: 'Options' as const },
                  id: 'options',
                  onClick: (event: MouseEvent<HTMLElement>) =>
                    setOptionsMenuAnchorEl(event.currentTarget),
                  tooltip: t('global', 'options')
                }
              ]
            : [])
        ].map((item) => {
          return (
            <Tooltip enterDelay={500} key={item.id} title={item.tooltip}>
              <IconButton
                color="disabled"
                onClick={item.onClick}
                onMouseDown={(event) => event.stopPropagation()}
                size="small"
                sx={{
                  width: ICON_BUTTON_SIZE,
                  height: ICON_BUTTON_SIZE
                }}
              >
                <Icon
                  name={item.icon.name}
                  sx={{
                    fontSize: ICON_SIZE
                  }}
                />
              </IconButton>
            </Tooltip>
          )
        })}

        {/*-- background --*/}
        <Box
          sx={{
            bgcolor: 'background.widget',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            right: 0,
            opacity: 0.9,
            borderBottomLeftRadius: 8 * scaleFactor,
            zIndex: -1
          }}
        />

        {/*-- menu --*/}
        {/* <ThemeProvider theme={getTheme('light')}> */}
        {options ? (
          <OptionsMenu
            anchorEl={optionsMenuAnchorEl}
            disableScrollLock={true}
            onClose={() => setOptionsMenuAnchorEl(null)}
            open={Boolean(optionsMenuAnchorEl)}
            options={options}
          />
        ) : null}
        {/* </ThemeProvider> */}
      </Box>
    </>
  )
}

export default GenericWidgetMenu
